<script setup>
import { sanitizeHtml } from '@core/utils/sanitizeHtml'

const props = defineProps({
  member: {
    type: Object,
    required: true
  },
  shortDescription: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: 'small',
  },
})
</script>

<template>
  <div>
    <div class="flex gap-1 flex-wrap">
      <template v-for="tag in member?.verifiedTags">
        <VMenu
          offset-y
          open-on-hover
          open-on-click
          close-on-content-click
        >
          <template #activator="{ props }">
            <VChip
              v-bind="props"
              :size="size"
              class="flex-shrink-0"
            >
              {{ tag.tagName }}
            </VChip>
          </template>
          <VCard class="verified-tag-popup">
            <VCardText
              v-if="tag.tagDescription"
              v-html="sanitizeHtml(tag.tagDescription)"
            />
            <VCardText v-else>
              Verified by RM
            </VCardText>
          </VCard>
        </VMenu>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.verified-tag-popup{
  max-width: 300px;
}
</style>
